// extracted by mini-css-extract-plugin
export var band = "PinnedAlerts-module--band--6f9d9";